import { ActionMenu } from "@telluscompany/design-system";
import { FileText, MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";

import type { InspectionListItem } from "../../api/inspection";

interface InspectionsActionMenuProps {
  row: InspectionListItem;
  canDelete: boolean;
  onOpen: (row: InspectionListItem) => void;
  onDelete: (row: InspectionListItem) => void;
}

/** Menu de linha no padrão Admin (`ActionMenu` + Lucide — inspection.md §6.0). */
const InspectionsActionMenu = ({
  row,
  canDelete,
  onOpen,
  onDelete,
}: InspectionsActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("inspection.actions.openForm"),
          onClick: () => onOpen(row),
          icon: <FileText size={16} />,
        },
        ...(canDelete
          ? [
              {
                label: translate("inspection.actions.delete"),
                onClick: () => onDelete(row),
                icon: <Trash2 size={16} />,
                colorTitle: "red" as const,
              },
            ]
          : []),
      ],
    },
  ];

  return (
    <ActionMenu
      menu={actions}
      trigger={
        <MoreVerticalIcon data-testid="inspection-action-menu-trigger" />
      }
    />
  );
};

export default InspectionsActionMenu;
